import gql from "graphql-tag";
import LockablePostFields from "../../fragments/engagement/LockablePostFields";

export default gql`
  mutation UnlockPost($objectId: ID!) {
    unlockPost(objectId: $objectId) {
      ...LockablePostFields
    }
  }

  ${LockablePostFields}
`;
